import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { generateProductsByPriceLevelSearchParams } from "../../../../utils/search/utils"
import { isError } from "../../../helpers/Error"
import ItemsResult from "../models/productPricesWithProductInfoItemsResult"
import { ProductPricesWithProductInfoSearchPayload } from "./types"

class Service {
    static async getProductPricesWithProductInfo(payload: ProductPricesWithProductInfoSearchPayload): Promise<ItemsResult> {
        const params = generateProductsByPriceLevelSearchParams({
            ...payload,
            filters: {
                "{oneOf}": {
                    "priceLevelId.keyword": payload.priceLevelId,
                    "priceLevelId": payload.priceLevelId,
                }
            }})

        const res = await AppContext.getApiClient()
            .post("/listing/price-with-products-info/search", params)

        if (isError(res)) {
            throw new Error(res.message)
        }

        return new ItemsResult(res)
    }
}

export {
    Service
}



// WEBPACK FOOTER //
// ./src/state/listing/product-price/service/service.ts